import { SR_API_ACTION_UTILITY_ACTIVATION_GET_ORDER_HITLIST_BY_SALES_REP } from 'api/utilityActionTypes';

export default async function getOrderHitlistCountBySalesRep(
  { state, utilityApiClient },
  { utilitySalesRepId },
) {
  const statePath = ['utilityActivations', 'countBySalesRep', utilitySalesRepId];

  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_GET_ORDER_HITLIST_BY_SALES_REP,
    state: state,
    payload: {
      utilitySalesRepId,
    },
    onSuccess(utilityActivationsCount) {
      state.set(statePath, utilityActivationsCount);
      state.commit();
    },
  });
}
